import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Map from '../views/Map.vue';
import Project from '../views/Project.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    children: [
      {
        path: '/:projectSchema',
        component: Project,
        children: [
          {
            path: 'page_in_development',
            name: 'pageInDevelopment',
            component: () =>
              import(/* webpackChunkName: "private" */ '../views/PageInDevelopment.vue'),
          },
          {
            path: 'map',
            name: 'map',
            props: true,
            component: Map,
          },
          {
            path: 'sections',
            name: 'gisogdSections',
            props: true,
            // route level code-splitting
            // this generates a separate chunk (docs.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
              import(/* webpackChunkName: "docs" */ '../views/GisogdSections.vue'),
          },
          {
            path: 'sections/:gisogdSection/docs',
            name: 'gisogdSectionDocs',
            props: true,
            component: () =>
              import(/* webpackChunkName: "docs" */ '../views/GisogdSectionDocs.vue'),
          },
          {
            path: 'sections/:gisogdSection/docs/:docId',
            name: 'gisogdDoc',
            props: true,
            component: () =>
              import(/* webpackChunkName: "docs" */ '../views/GisogdDoc.vue'),
          },
        ],
      },
    ],
  },
  {
    name: 'error',
    path: '/error',
    props: true,
    component: () =>
      import(/* webpackChunkName: "error" */ '../views/ErrorPage.vue'),
  },
  {
    path: '*',
    redirect: { name: 'home' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'is-active' /* change to Bulma's active nav link */,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return new Promise((resolve) => {
        this.app.$root.$once('triggerScroll', () => {
          setTimeout(() => {
            resolve(savedPosition);
          }, 500);
        });
      });
    } else {
      return { x: 0, y: 0 };
    }
  },
});
router.afterEach((to) => {
  if (to.name === 'map') document.documentElement.style.overflowY = 'hidden';
  else document.documentElement.style.overflowY = 'auto';
});
export default router;
